// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","copyright":"Footer_copyright__JQMtz"};